import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SalesOrderSelectorComponent } from './sales-order-selector.component';
import { LoaderTableModule } from 'src/app/widgets/loaders/loader-table/loader-table.module';
import { MatButtonModule } from '@angular/material/button';
import { ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [SalesOrderSelectorComponent],
  exports: [SalesOrderSelectorComponent],
  imports: [
    CommonModule,
    LoaderTableModule,
    MatButtonModule,
    ReactiveFormsModule
  ]
})
export class SalesOrderSelectorModule { }
